module.exports = __webpack_public_path__ + "static/media/placeholder.a5c7ea07.jpg";